import { isImgFile } from '@/scripts/utils/file-analyzer';
import UNKNOWN from './images/UNKNOWN.svg';

interface FileTypeIconProps {
  extType: string;
  file?: File;
  src?: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

export const FileTypeIcon = ({
  extType,
  file,
  src,
  width = 34,
  height = 34,
  style = { borderRadius: 5 },
}: FileTypeIconProps) => {
  const [iconUrl, setIconUrl] = useState<string>(UNKNOWN);
  const objectURLRef = useRef<string>('');

  useLayoutEffect(() => {
    (async () => {
      if (src) {
        setIconUrl(src);
        return;
      }
      if (isImgFile(file?.type)) {
        const objectURL = URL.createObjectURL(file!);
        objectURLRef.current = objectURL;
        setIconUrl(objectURL);
        return;
      }
      try {
        const iconModule = new URL(
          `./images/${extType.toUpperCase()}.svg`,
          import.meta.url
        ).pathname;
        setIconUrl(iconModule);
      } catch (_) {
        setIconUrl(UNKNOWN);
      }
    })();
  }, [file, extType, src]);

  useEffect(() => {
    return () => {
      if (objectURLRef.current) {
        URL.revokeObjectURL(objectURLRef.current);
      }
    };
  }, []);

  return (
    <img
      src={iconUrl}
      width={width}
      height={height}
      style={style}
      onError={() => {
        setIconUrl(UNKNOWN);
      }}
    />
  );
};
